import React, { Component } from 'react';
import {
  Button,
  Checkbox,
  Glyphicon,
  MenuItem,
  OverlayTrigger,
  Popover,
  DropdownButton,
  Tooltip,
} from 'react-bootstrap';
import axios from 'axios';
import _ from 'underscore';
import { humanize, underscored, titleize } from 'underscore.string';
import CustomerSearch from 'components/site/customer-search';
import ExceptionStore from 'stores/ExceptionStore';
import SessionStore from 'stores/SessionStore';
import DataList from 'components/ui/DataList';
import AccessorialsConfirmationModal from 'components/modules/shipments/accessorials/ConfirmationModal';
import AccessorialRequestActionCreators from 'actions/AccessorialRequestActionCreators';
import AccessorialRequestPane from 'components/modules/shipments/AccessorialRequestPane';
import Container from 'components/v2/container';
import CargomaticModal from 'components/v2/modal';
import CargomaticPane from 'components/v2/pane';
import CargomaticSelect from 'components/v2/select';
import Badge from 'components/v2/Badge';
import ShipmentModule from 'components/modules/shipments/Shipment';
import Multiselect from 'components/v2/multi-select';
import { getAccessorials } from 'utils/AccessorialWebAPIUtils';
import { getDeclinedAccessorialsReasonCodes } from 'utils/ReasonCodesAPI';
import ToastStore, { showToast } from 'stores/ToastStore';
import Label from 'components/v2/forms/Label';
import { downloadAccessorialExceptionsCSV } from 'utils/AccessorialRequestWebAPIUtils';
import { Translation, withTranslation } from 'react-i18next';
import { CONFIGURED_FEATURES, featureEnabled } from 'helpers/feature-flags';
import moment from 'moment';
import DateRangeFilter from 'components/time/DateRangeFilter';
import CalendarIcon from 'components/v2/icons/CalendarIcon';
import { getDefaultDateRangeFilter } from 'helpers/date-range';
import { OPS_GROUP_OPTIONS } from 'constants/shipper';
import { MARKET_REGIONS_US } from 'constants/Regions';
import { checkProcessedAccessorial, checkIfAccessorialsNeedsReview, checkIfEquipmentIsMissing } from 'helpers/accessorials';
import CargomaticInput from 'components/v2/input';
import AdminAccessorialMapping from './AdminAccessorialMapping';
import MultiEquipmentInput from '../orders/equipments/MultiEquipmentInput';
import ExportAccessorialExceptionCSV from './ExportAccessorialExceptionCSV';
import BulkAddAccessorialsModal from '../shipments/accounting/BulkAddAccessorialsModal';
import CargomaticAlert from 'components/ui/Alert';
import {
  Button as UIButton,
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@cargomatic/ui';
import ChevronDownIcon from 'components/v2/icons/ChevronDownIcon';

const STATUS = [
  { localizationSlug: 'PENDING_ADMIN', value: 'pending-admin' },
  { localizationSlug: 'PENDING_SHIPPER', value: 'pending-shipper' },
  { localizationSlug: 'ACCEPTED', value: 'accepted' },
  { localizationSlug: 'APPROVED', value: 'approved' },
  { localizationSlug: 'DECLINED', value: 'declined' },
];
const ACTION_TYPES = [
  { localizationSlug: 'AWAITING_ADMIN_REVIEW', value: 'Awaiting Admin Review' },
  {
    localizationSlug: 'AWAITING_SHIPPER_RESPONSE',
    value: 'Awaiting Shipper Response',
  },
];

const PAYEE_TYPES = ['carrier', 'vendor'];

const DEFAULT_DATE_RANGE_VALUES = {
  startValue: 2,
  startTimeUnit: 'month',
  startKey: {
    key: 'created_at',
  },
};

const MISSING_DOCS_VALUES = [{ localizationSlug: 'MISSING', value: true }];

const TOOLTIPS = {
  MISSING_DOCS: (
    <Tooltip id="missing_accessorial_docs" style={{ zIndex: 99999 }}>
      <Translation>{(t) => t('MISSING_ACCESSORIAL_DOCS')}</Translation>
    </Tooltip>
  ),
};

class AccessorialExceptions extends Component {
  constructor(props) {
    super(props);
    const user = SessionStore.getUser();
    const initial = {
      user,
      pages: 1,
      per_page: 25,
      activePage: 1,
      exceptions: [],
      action_types: [],
      payee_types: [],
      selectedIds: [],
      accessorials: [],
      selected_accessorials: [],
      selected: [],
      statuses: [],
      referenceShipments: [],
      missing_docs: false,
      inputReferences: '',
      shipper: [],
      master_shipper: [],
      action: null,
      shouldPoll: true,
      openBulkAssignModal: false,
      showShipmentDetailsModal: false,
      showShipmentDetailsShipment: null,
      showAccessorialRequestPane: false,
      showAccessorialRequestId: null,
      showAccessorialRequestShipment: null,
      carrier: [],
      carrier_statuses: ['pending-admin'],
      shipper_statuses: ['pending-admin'],
      loading: true,
      cancelTokenSource: null,
      exportCSV: true,
      date_range: getDefaultDateRangeFilter(DEFAULT_DATE_RANGE_VALUES),
      carrier_decline_reason_code: null,
      accessorialsReasonCodes: [],
      ops_group: [],
      market_regions: [],
      quickpay_carrier: false,
      needs_review: null
    };

    this.state = initial;
  }

  componentDidMount() {
    ExceptionStore.addChangeListener(this.onChange);
    ExceptionStore.addAccessorialRequestChangeListener(this.onUpdate);
    this.updateAccessorialsView();
    this.fetchAccessorials();
    this.fetchReasonCodes();
    document.title = 'Cargomatic Inc. - Accessorial Exceptions';
  }

  componentWillUnmount() {
    this.cancelRequest();
    ExceptionStore.removeChangeListener(this.onChange);
    ExceptionStore.removeAccessorialRequestChangeListener(this.onUpdate);
  }

  cancelRequest() {
    const { cancelTokenSource } = this.state;
    if (cancelTokenSource) {
      cancelTokenSource.cancel();
    }
  }

  formatAccessorialRequestQuery() {
    const {
      referenceShipments,
      activePage,
      shipper,
      master_shipper,
      carrier,
      carrier_statuses,
      shipper_statuses,
      action_types,
      payee_types,
      sortField,
      sortOrder,
      selected_accessorials,
      date_range,
      carrier_decline_reason_code,
      ops_group,
      missing_docs,
      market_regions,
      quickpay_carrier,
      needs_review
    } = this.state;
    let query = {};
    query.paginate = true;
    query.page = activePage;
    query.per_page = this.state.per_page;
    if (shipper) query.shipper = shipper.map((shipperEl) => shipperEl.value);
    if (master_shipper)
      query.master_shipper = master_shipper.map((shipperEl) => shipperEl.value);
    if (carrier) query.carrier = carrier.map((carrier) => carrier.value);
    if (carrier_statuses && carrier_statuses.length)
      query.carrier_status = carrier_statuses;
    if (shipper_statuses && shipper_statuses.length)
      query.shipper_status = shipper_statuses;
    if (action_types) query.action_required = action_types;
    if (payee_types) query.payee_type = payee_types;
    if (ops_group) query.operations_group = ops_group;
    if (selected_accessorials?.length > 0)
      query.accessorial_type = selected_accessorials;
    if (referenceShipments) query.id = referenceShipments;
    if (sortField) {
      if (sortField === 'status') {
        query.sort_by = 'carrier_status'; // SHould we sort by carrier or shipper status?
      } else {
        query.sort_by = sortField;
      }
    }
    if (sortOrder) query.order = sortOrder;
    if (sortOrder && sortField) query.sort = true;
    if (date_range) query.date_range = date_range;
    if (carrier_decline_reason_code)
      query.carrier_decline_reason_code = carrier_decline_reason_code;
    if (missing_docs) {
      query.missing_docs = !!missing_docs;
    }
    if (market_regions) query.market_regions = market_regions;
    if (quickpay_carrier) query.quickpay_carrier = quickpay_carrier;

    if (needs_review !== null) {
      query.needs_review = !!needs_review
    }
    return query;
  }

  updateAccessorialsView() {
    const { cancelTokenSource } = this.state;
    if (cancelTokenSource) {
      this.cancelRequest();
    }
    if (this.state.shouldPoll) {
      const source = axios.CancelToken.source();
      const options = {
        cancelToken: source.token,
      };
      this.setState({
        exceptions: [],
        loading: true,
        cancelTokenSource: source,
      });
      const query = this.formatAccessorialRequestQuery();
      AccessorialRequestActionCreators.getAccessorialRequests(query, options);
    }
  }

  onUpdate = () => {
    this.updateAccessorialsView();
  };

  onChange = () => {
    const result = ExceptionStore.getAllAccessorialPaginatedRequests();
    const { totalCount, totalPages, items } = result;

    const exceptions = items.map((exception) => {
      return {
        ...exception,
        // Add functions for the formatters used in the DataList.
        showShipmentModal: this.showShipmentModal.bind(this),
        showAccessorialRequestPane: this.showAccessorialRequestPane.bind(this),
      };
    });

    this.setState({
      loading: false,
      pages: totalPages,
      totalCount,
      exceptions,
      submitting: false,
      cancelTokenSource: null,
    });
  };

  fetchAccessorials = async () => {
    try {
      const result = await getAccessorials({ paginate: false });
      const {
        entity: { items },
      } = result;

      const accessorials = items.map((a) => ({
        ...a,
        slug: a.slug || underscored(a.name.toLowerCase()),
      }));
      this.setState({
        accessorials,
      });
    } catch (e) {
      const { t } = this.props;
      ToastStore.addNotification({
        title: t('LOADING_ACCESSORIALS_ERROR'),
        body: '',
        level: 'error',
      });
    }
  };

  fetchReasonCodes = async () => {
    try {
      const accessorialsReasonCodes =
        await getDeclinedAccessorialsReasonCodes();

      this.setState({
        accessorialsReasonCodes,
      });
    } catch (err) {
      console.log('Error during get decline reason codes: ', err);
    }
  };

  getHandleAccessorialTypeChange = (accessorials) => {
    const selected_accessorials = accessorials.map((ac) => ac.slug);
    this.setState({ selected_accessorials }, () =>
      this.updateAccessorialsView(),
    );
  };

  renderCarrierFilter() {
    const { t } = this.props;
    return (
      <div className="mb-4">
        <label className="form-label mb-2 block">
          {t('FILTER_BY_CARRIER')}
        </label>
        <CustomerSearch
          clearOnSelect
          type="carriers"
          onSelect={(_item, value) => this.filterByCarrier(value)}
          placeholder={t('SEARCH_FOR_CARRIERS')}
        />
        {this.state.carrier.length > 0 && (
          <div className="flex flex-wrap -mx-2 mt-2 mb-4">
            {this.state.carrier.map((carrier) => (
              <div className="px-2 mb-2" key={carrier}>
                <Badge
                  color="blue"
                  withRemove
                  onRemove={this.handleRemoveCarrier(carrier)}
                >
                  {carrier.name}
                </Badge>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  renderShipperFilter = () => {
    const { t } = this.props;
    return (
      <div className="mb-4">
        <label className="form-label block mb-2">
          {t('FILTER_BY_SHIPPER')}
        </label>
        <CustomerSearch
          clearOnSelect
          type="shippers"
          onSelect={(_item, value) => {
            this.filterByShipper(value);
          }}
          placeholder={t('SEARCH_FOR_SHIPPER_PLACEHOLDER')}
        />
        {this.state.shipper && (
          <div className="flex flex-wrap -mx-2 mt-2 mb-4">
            {this.state.shipper.map((shipper) => (
              <div className="px-2 mb-2" key={shipper.value}>
                <Badge
                  color="blue"
                  withRemove
                  onRemove={() => this.handleRemoveShipper(shipper.value)}
                >
                  {shipper.name}
                </Badge>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  renderMasterAccountFilter = () => {
    const { t } = this.props;
    return (
      <div className="mb-4">
        <label className="form-label block mb-2">
          {t('FILTER_BY_MASTER_ACCOUNT')}
        </label>
        <CustomerSearch
          clearOnSelect
          type="master_shippers"
          onSelect={(_item, value) => {
            this.filterByMasterShipper(value);
          }}
          placeholder={t('SEARCH_FOR_MASTER_ACCOUNT')}
        />
        {this.state.master_shipper && (
          <div className="flex flex-wrap -mx-2 mt-2 mb-4">
            {this.state.master_shipper.map((shipper) => (
              <div className="px-2 mb-2" key={shipper.value}>
                <Badge
                  color="blue"
                  withRemove
                  onRemove={() => this.handleRemoveMasterShipper(shipper.value)}
                >
                  {shipper.name}
                </Badge>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  renderPayeeTypeFilter() {
    const { t } = this.props;
    return (
      <div className="dropdown-filter-wrapper mb-4">
        <label className="form-label block mb-2">
          {t('FILTER_BY_PAYEE_TYPE')}
        </label>
        <OverlayTrigger
          className="dropdown-filter-wrapper"
          rootClose
          trigger="click"
          placement="bottom"
          overlay={this.renderPayeeTypesPopup()}
        >
          <div>
            <Button
              bsStyle={this.state.payee_types.length > 0 ? 'danger' : 'default'}
              style={{ outline: 'none' }}
              bsSize="small"
            >
              <strong>{`${t('PAYEE_TYPES')} :`} </strong>
              <Glyphicon glyph="chevron-down" className="button-down-glyph" />
            </Button>
          </div>
        </OverlayTrigger>
      </div>
    );
  }

  renderOPSGroupFilter() {
    const { t } = this.props;
    return (
      <div className="dropdown-filter-wrapper mb-4">
        <label className="form-label block mb-2">
          {t('FILTER_BY_OPS_GROUP')}
        </label>
        <OverlayTrigger
          className="dropdown-filter-wrapper"
          rootClose
          trigger="click"
          placement="bottom"
          overlay={this.renderOPSGroupPopup()}
        >
          <div>
            <Button
              bsStyle={this.state.ops_group.length > 0 ? 'danger' : 'default'}
              style={{ outline: 'none' }}
              bsSize="small"
            >
              <strong>{`${t('OPS_GROUP')} :`} </strong>
              <Glyphicon glyph="chevron-down" className="button-down-glyph" />
            </Button>
          </div>
        </OverlayTrigger>
      </div>
    );
  }

  onDateRangeChange = ({ filterType, start, end }) => {
    this.setState(
      (prevState) => {
        const filters = prevState;
        if (filterType === 'clear') {
          filters.date_range = getDefaultDateRangeFilter(
            DEFAULT_DATE_RANGE_VALUES,
          );
        } else {
          filters.date_range = {
            key: filterType === 'requested' ? 'created_at' : 'deliver_after',
            start: moment(start).toISOString(),
            end: moment(end).toISOString(),
          };
        }
        filters.activePage = 1;
        return { ...filters };
      },
      () => this.updateAccessorialsView(),
    );
  };

  renderDateRangeFilter() {
    const { date_range } = this.state;
    const { t } = this.props;
    const defaultDates = getDefaultDateRangeFilter({
      options: 'object',
      ...DEFAULT_DATE_RANGE_VALUES,
    });

    return (
      <div className="mb-4">
        <Label className="block mb-2">{t('FILTER_BY_DATE_RANGE')}</Label>
        <DateRangeFilter
          buttonClassName="flex w-full button bg-white border shadow justify-center"
          onChange={this.onDateRangeChange}
          initialStart={defaultDates.start}
          initialEnd={defaultDates.end}
          startKey="requested"
          endKey="delivery"
          label={
            <div className="flex space-x-1">
              <span className="text-green">
                <CalendarIcon />
              </span>
              <span className="font-normal text-sm text-grey-darker">
                {t('DATE_RANGE')}
              </span>
            </div>
          }
          updateBool={date_range?.start && date_range?.end}
        />
      </div>
    );
  }

  renderMissingDocumentsFilter = () => {
    const { t } = this.props;
    return (
      <div className="dropdown-filter-wrapper mb-4">
        <label className="form-label block mb-2">
          {t('FILTER_BY_MISSING_DOCS')}
        </label>
        <OverlayTrigger
          className="dropdown-filter-wrapper"
          rootClose
          trigger="click"
          placement="bottom"
          overlay={this.renderMissingDocumentsPopup()}
        >
          <div>
            <Button
              bsStyle={this.state.missing_docs ? 'danger' : 'default'}
              style={{ outline: 'none' }}
              bsSize="small"
            >
              <strong>{`${t('MISSING_DOCS_VALUES')} :`} </strong>
              <Glyphicon glyph="chevron-down" className="button-down-glyph" />
            </Button>
          </div>
        </OverlayTrigger>
      </div>
    );
  };

  renderPayeeTypesPopup() {
    const { t } = this.props;
    return (
      <Popover id="payee-types-popup">
        <ul className="filter-dropdown-wrapper">
          {PAYEE_TYPES.map((type, i) => {
            return (
              <li key={i}>
                <Checkbox
                  onChange={(e) =>
                    this.filterByPayeeTypes(type, e.target.checked)
                  }
                  checked={this.state.payee_types.indexOf(type) > -1}
                >
                  {humanize(t(type.toUpperCase(), { count: 1 }))}
                </Checkbox>
              </li>
            );
          })}
        </ul>
      </Popover>
    );
  }

  renderOPSGroupPopup() {
    const { t } = this.props;
    return (
      <Popover id="payee-types-popup">
        <ul className="filter-dropdown-wrapper">
          {OPS_GROUP_OPTIONS.map((type, i) => {
            return (
              <li key={i}>
                <Checkbox
                  onChange={(e) =>
                    this.filterByOPSGroups(type.slug, e.target.checked)
                  }
                  checked={this.state.ops_group.indexOf(type.slug) > -1}
                >
                  {t(type.localizationSlug)}
                </Checkbox>
              </li>
            );
          })}
        </ul>
      </Popover>
    );
  }

  renderActionTypesPopup() {
    const { t } = this.props;
    return (
      <Popover id="exception-types-popup">
        <ul className="filter-dropdown-wrapper">
          {ACTION_TYPES.map((type, i) => {
            return (
              <li key={i}>
                <Checkbox
                  onChange={(e) =>
                    this.filterByActionTypes(type.value, e.target.checked)
                  }
                  checked={this.state.action_types.indexOf(type.value) > -1}
                >
                  {t(type.localizationSlug)}
                </Checkbox>
              </li>
            );
          })}
        </ul>
      </Popover>
    );
  }

  renderMissingDocumentsPopup = () => {
    const { t } = this.props;
    return (
      <Popover id="exception-types-popup">
        <ul className="filter-dropdown-wrapper">
          {MISSING_DOCS_VALUES.map((value, i) => {
            return (
              <li key={i}>
                <Checkbox
                  onChange={(e) =>
                    this.filterByMissingDocuments(e.target.checked)
                  }
                  checked={!!this.state.missing_docs}
                >
                  {t(value.localizationSlug)}
                </Checkbox>
              </li>
            );
          })}
        </ul>
      </Popover>
    );
  };

  renderAccesorialTypes() {
    const { t } = this.props;
    const { accessorials } = this.state;
    const accessorial_types = accessorials.map((type) => {
      return {
        name: type.name,
        slug: type.slug,
        selected: this.state.selected_accessorials.indexOf(type.slug) > -1,
      };
    });

    return (
      <div className="mb-4">
        <label className="form-label mb-2 block">
          {t('FILTER_BY_ACCESSORIAL_NAME')}
        </label>
        <Multiselect
          label={t('SELECT_ACCESSORIAL_TYPES')}
          items={accessorial_types}
          onSelect={this.getHandleAccessorialTypeChange}
        />
      </div>
    );
  }

  filterByCarrier(value) {
    this.setState(
      (prevState) => {
        const carrier = _.uniq(
          (prevState.carrier || []).concat(value),
          (carrier) => carrier.value,
        );
        return {
          ...prevState,
          activePage: 1,
          carrier,
        };
      },
      () => this.updateAccessorialsView(),
    );
  }

  filterByShipper(value) {
    this.setState(
      (prevState) => {
        return {
          shipper: _.uniq(
            prevState.shipper.concat(value),
            (shipperEl) => shipperEl.value,
          ),
          activePage: 1,
        };
      },
      () => this.updateAccessorialsView(),
    );
  }

  handleRemoveShipper = (id) => {
    this.setState(
      (prevState) => ({
        shipper: prevState.shipper.filter(
          (shipperEl) => shipperEl.value !== id,
        ),
      }),
      () => this.updateAccessorialsView(),
    );
  };

  filterByMasterShipper(value) {
    this.setState(
      (prevState) => {
        return {
          master_shipper: _.uniq(
            prevState.master_shipper.concat(value),
            (shipperEl) => shipperEl.value,
          ),
          activePage: 1,
        };
      },
      () => this.updateAccessorialsView(),
    );
  }

  handleRemoveMasterShipper = (id) => {
    this.setState(
      (prevState) => ({
        master_shipper: prevState.master_shipper.filter(
          (shipperEl) => shipperEl.value !== id,
        ),
      }),
      () => this.updateAccessorialsView(),
    );
  };

  renderStatusPopup(isShipper) {
    const { t } = this.props;
    return (
      <Popover id="exception-types-popup">
        <ul className="filter-dropdown-wrapper">
          {STATUS.map((type, i) => {
            return (
              <li key={i}>
                <Checkbox
                  onChange={(e) =>
                    this.filterByStatus(isShipper, type.value, e.target.checked)
                  }
                  checked={
                    isShipper
                      ? this.state.shipper_statuses.indexOf(type.value) > -1
                      : this.state.carrier_statuses.indexOf(type.value) > -1
                  }
                >
                  {humanize(t(type.localizationSlug))}
                </Checkbox>
              </li>
            );
          })}
        </ul>
      </Popover>
    );
  }

  /*
   * This method is called on table change for all table events. We currently only
   * support remote sorting for the columns on this page.
   */
  onTableChange(type, newState) {
    if (type === 'sort') {
      if (newState) {
        const { sortField, sortOrder } = newState;
        this.setState(
          {
            sortField,
            sortOrder,
            activePage: 1,
          },
          () => this.updateAccessorialsView(),
        );
      }
    }
  }

  renderActionTypes() {
    const { t } = this.props;
    return (
      <div className="dropdown-filter-wrapper mb-4">
        <label className="form-label block mb-2">
          {t('FILTER_BY_ACTION_REQUIRED')}
        </label>
        <OverlayTrigger
          className="dropdown-filter-wrapper"
          rootClose
          trigger="click"
          placement="bottom"
          overlay={this.renderActionTypesPopup()}
        >
          <div>
            <Button
              bsStyle={
                this.state.action_types.length > 0 ? 'danger' : 'default'
              }
              style={{ outline: 'none' }}
              bsSize="small"
            >
              <strong>{`${t('ACTION_TYPES')}: `} </strong>
              <Glyphicon glyph="chevron-down" className="button-down-glyph" />
            </Button>
          </div>
        </OverlayTrigger>
      </div>
    );
  }

  renderReasonCode() {
    const { t } = this.props;
    const { accessorialsReasonCodes, carrier_decline_reason_code } = this.state;

    return (
      <div className="mb-4">
        <CargomaticSelect
          items={accessorialsReasonCodes}
          value={carrier_decline_reason_code}
          className="w-auto"
          label={t('FILTER_BY_REASON_CODE')}
          labelClassName="form-label mb-2 block"
          showCaption
          onSelect={(value) => this.onDeclineReasonCodeChange(value)}
        />
      </div>
    );
  }

  onDeclineReasonCodeChange = (value) => {
    this.setState(
      {
        carrier_decline_reason_code: value,
      },
      () => this.updateAccessorialsView(),
    );
  };

  handleSelection(accessorial, checked) {
    const { selectedIds: currentSelectedIds, exceptions } = this.state;

    let selectedIds;
    if (checked) {
      selectedIds = [...currentSelectedIds, accessorial._id];
    } else {
      const index = currentSelectedIds.findIndex((s) => s === accessorial._id);
      if (index !== -1) {
        selectedIds = [
          ...currentSelectedIds.slice(0, index),
          ...currentSelectedIds.slice(index + 1),
        ];
      } else {
        selectedIds = [...currentSelectedIds];
      }
    }

    const selected = exceptions.filter((s) => selectedIds.includes(s._id));
    const unprocessedAccessorials = selected.filter(
      (accessorial) => !checkProcessedAccessorial(accessorial),
    );
    selectedIds = unprocessedAccessorials.map((acc) => acc._id);
    this.setState({
      selectedIds,
      selected: unprocessedAccessorials,
      selectAll: false,
    });
  }

  handleSelectAll(checked) {
    const { exceptions } = this.state;

    let selected = [];
    let selectedIds = [];

    if (checked) {
      selected = exceptions.filter(
        (accessorial) => !checkProcessedAccessorial(accessorial),
      );
      selectedIds = selected.map((acc) => acc._id);
    }

    this.setState({
      selectedIds,
      selected,
      selectAll: checked,
    });
  }

  handleAccessorialRemove = (accessorialId) => {
    this.setState((prevState) => {
      const currentSelectedIds = prevState.selectedIds;
      const currentSelected = prevState.selected;
      const selectedIds = currentSelectedIds.filter(
        (id) => id !== accessorialId,
      );
      return {
        selectedIds,
        selected: (prevState?.exceptions || []).filter((s) =>
          selectedIds.includes(s._id),
        ),
      };
    });
  };

  handleRemoveCarrier = (id) => () => {
    this.setState(
      (prevState) => {
        const index = prevState.carrier.findIndex((s) => s === id);
        return {
          ...prevState,
          carrier: [
            ...prevState.carrier.slice(0, index),
            ...prevState.carrier.slice(index + 1),
          ],
          activePage: 1,
        };
      },
      () => this.updateAccessorialsView(),
    );
  };

  onShipmentFilterClear(item) {
    this.setState(
      (prev) => {
        return {
          ...prev,
          activePage: 1,
          referenceShipments: prev.referenceShipments.filter(
            (shipment) => shipment !== item,
          ),
        };
      },
      () => this.updateAccessorialsView(),
    );
  }

  renderFilterbyStatus(isShipper) {
    const { t } = this.props;
    var statuses = isShipper
      ? this.state.shipper_statuses
      : this.state.carrier_statuses;
    return (
      <div className="dropdown-filter-wrapper mb-4">
        <label className="form-label block mb-2">
          {isShipper
            ? t('FILTER_BY_SHIPPER_STATUS')
            : t('FILTER_BY_CARRIER_STATUS')}
        </label>
        <OverlayTrigger
          className="dropdown-filter-wrapper"
          rootClose
          trigger="click"
          placement="bottom"
          overlay={this.renderStatusPopup(isShipper)}
        >
          <div>
            <Button
              bsStyle={statuses.length > 0 ? 'danger' : 'default'}
              style={{ outline: 'none' }}
              bsSize="small"
            >
              <strong>
                {isShipper
                  ? `${t('SHIPPER_STATUS')}: `
                  : `${t('CARRIER_STATUS')}: `}
              </strong>
              <Glyphicon glyph="chevron-down" className="button-down-glyph" />
            </Button>
          </div>
        </OverlayTrigger>
      </div>
    );
  }

  filterByActionTypes(type, checked) {
    let action_types = [...this.state.action_types];
    if (checked) {
      action_types.push(type);
    } else {
      action_types = _.without(action_types, type);
    }
    this.setState(
      (prevState) => {
        return {
          ...prevState,
          action_types,
          activePage: 1,
        };
      },
      () => this.updateAccessorialsView(),
    );
  }

  filterByPayeeTypes(type, checked) {
    let payee_types = [...this.state.payee_types];
    if (checked) {
      payee_types.push(type);
    } else {
      payee_types = _.without(payee_types, type);
    }
    this.setState(
      (prevState) => {
        return {
          ...prevState,
          payee_types,
          activePage: 1,
        };
      },
      () => this.updateAccessorialsView(),
    );
  }

  filterByOPSGroups(type, checked) {
    let ops_group = [...this.state.ops_group];
    if (checked) {
      ops_group.push(type);
    } else {
      ops_group = _.without(ops_group, type);
    }
    this.setState(
      (prevState) => {
        return {
          ...prevState,
          ops_group,
          activePage: 1,
        };
      },
      () => this.updateAccessorialsView(),
    );
  }

  filterByStatus(isShipper, status, checked) {
    let statuses = isShipper
      ? [...this.state.shipper_statuses]
      : [...this.state.carrier_statuses];
    if (checked) {
      statuses.push(status);
    } else {
      statuses = _.without(statuses, status);
    }
    if (isShipper) {
      this.setState(
        {
          shipper_statuses: statuses,
          activePage: 1,
        },
        () => this.updateAccessorialsView(),
      );
    } else {
      this.setState(
        {
          carrier_statuses: statuses,
          activePage: 1,
        },
        () => this.updateAccessorialsView(),
      );
    }
  }

  filterByMissingDocuments(missing_docs) {
    this.setState((prevState) => {
      return {
        ...prevState,
        missing_docs,
        activePage: 1,
      };
    }, this.updateAccessorialsView);
  }

  filterByMarketRegions(type, checked) {
    let market_regions = [...this.state.market_regions];
    if (checked) {
      market_regions.push(type);
    } else {
      market_regions = _.without(market_regions, type);
    }
    this.setState(
      (prevState) => {
        return {
          ...prevState,
          market_regions,
          activePage: 1,
        };
      },
      () => this.updateAccessorialsView(),
    );
  }

  renderShipmentFilter = () => {
    const { t } = this.props;
    return (
      <div className="mb-4">
        <Label helptext={t('INPUT_HELPTEXT')} className="form-label block mb-2">
          {t('FILTER_BY_ANY_REFERENCE')}{' '}
        </Label>
        <div className="flex flex-row">
          <MultiEquipmentInput
            onChange={(inputReferences) => {
              this.setState({ inputReferences });
            }}
            value={this.state.inputReferences}
            rows={1}
          />
          <button
            className="button button-green ml-2"
            onClick={() => this.filterByShipment()}
          >
            {titleize(t('ADD'))}
          </button>
        </div>
        <div className="flex flex-wrap items-center justify-start mt-2">
          {this.state.referenceShipments.map((el) => {
            return (
              <div className="mt-2 mr-2" key={el}>
                <Badge
                  color="green"
                  withRemove
                  onRemove={() => this.onShipmentFilterClear(el)}
                >
                  {el}
                </Badge>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  handleBulkAction = (bulkAction) => {
    var action;
    switch (bulkAction) {
      case 'Edit':
        action = 'edit';
        break;
      case 'Decline':
        action = 'decline_all';
        break;
      case 'Approve':
        action = 'approve_all';
        break;
      case 'Notify Shipper':
        action = 'notify_all';
        break;
      default:
        break;
    }
    this.setState({
      action,
      openBulkAssignModal: action !== 'edit',
    });
  };

  showAccessorialRequestPane = (accessorial) => {
    this.setState({
      showAccessorialRequestPane: true,
      showAccessorialRequestId: accessorial._id,
      showAccessorialRequestShipment: accessorial.shipment,
    });
  };

  hideAccessorialRequestPane = () => {
    this.setState({
      showAccessorialRequestPane: false,
      showAccessorialRequestId: null,
      showAccessorialRequestShipment: null,
    });
  };

  showShipmentModal = (shipment_id) => {
    this.setState({
      showShipmentDetailsModal: true,
      shouldPoll: false,
      showShipmentDetailsShipment: shipment_id,
    });
  };

  hideShipmentModal = () => {
    this.setState({
      showShipmentDetailsModal: false,
      shouldPoll: true,
      showShipmentDetailsShipment: null,
    });
  };

  onPaginationSelect(page) {
    this.setState(
      {
        activePage: page,
      },
      () => this.updateAccessorialsView(),
    );
  }

  filterByShipment() {
    const value = this.state.inputReferences;
    const newReferences = [];

    if (value) {
      // Build a unique array of equipment objects
      const items = value.replace(/\n/g, ',').split(',');
      const unique = {};
      _.each(items, (item) => {
        item = item.trim();
        if (item && item !== '' && !unique[item]) {
          unique[item] = true;
          newReferences.push(item);
        }
      });

      this.setState(
        (prev) => {
          return {
            activePage: 1,
            inputReferences: '',
            referenceShipments: _.uniq([
              ...prev.referenceShipments,
              ...newReferences,
            ]),
          };
        },
        () => this.updateAccessorialsView(),
      );
    }
  }

  handleAccessorialOnSubmit = (payload) => {
    switch (this.state.action) {
      case 'notify_all':
        AccessorialRequestActionCreators.updateAccessorialRequest(payload);
        return this.setState({
          action: '',
          selectedIds: [],
          openBulkAssignModal: false,
        });
      case 'approve_all':
        AccessorialRequestActionCreators.approveAccessorials(payload);
        return this.setState({
          action: '',
          selectedIds: [],
          openBulkAssignModal: false,
        });
      case 'decline_all':
        AccessorialRequestActionCreators.declineAccessorials(payload);
        return this.setState({
          action: '',
          selectedIds: [],
          openBulkAssignModal: false,
        });
      default:
        break;
    }
  };

  showExportCSVPopup = () => {
    this.setState((prev) => {
      return {
        exportCSV: !prev.exportCSV,
      };
    });
  };

  exportAccessorialsToCSV = async (columns) => {
    try {
      this.showExportCSVPopup();
      const query = this.formatAccessorialRequestQuery();
      query.page = 1;
      query.paginate = false;
      query.per_page = 5000;
      const { entity } = await downloadAccessorialExceptionsCSV(columns, query);
      const file = new Blob([entity], { type: 'text/csv' });
      const fileURL = URL.createObjectURL(file);
      const link = document.createElement('a');
      link.href = fileURL;
      link.download = 'accessorials_exceptions.csv';
      link.click();
      this.showExportCSVPopup();
    } catch (e) {
      const { t } = this.props;
      showToast(
        t('CSV_DOWNLOAD_FAILED'),
        t('CSV_DOWNLOAD_FAILED_ACCESSORIAL'),
        'error',
      );
      this.showExportCSVPopup();
    }
  };

  getDetailComponent() {
    const { showAccessorialRequestId, showAccessorialRequestShipment } =
      this.state;

    return (
      <AccessorialRequestPane
        accessorial={showAccessorialRequestId}
        shipment={showAccessorialRequestShipment}
        showAccessorialRequestPane
      />
    );
  }

  renderPane() {
    if (!this.state.showAccessorialRequestPane) {
      return null;
    }
    const { t } = this.props;
    return (
      <div>
        <div id="pane-container" />
        <CargomaticPane
          show={this.state.showAccessorialRequestPane}
          title={t('ACCESSORIAL_REQUESTS')}
          onHide={this.hideAccessorialRequestPane.bind(this)}
          renderBody={this.getDetailComponent.bind(this)}
          footer={null}
          className="sm:w-1/3 sm:max-w-none"
          maskClosable={false}
          location="right"
        />
      </div>
    );
  }

  renderMarketRegionsPopup() {
    const { t } = this.props;
    return (
      <Popover id="exception-types-popup">
        <ul className="filter-dropdown-wrapper">
          {MARKET_REGIONS_US.map((type, i) => {
            return (
              <li key={i}>
                <Checkbox
                  onChange={(e) =>
                    this.filterByMarketRegions(type.value, e.target.checked)
                  }
                  checked={this.state.market_regions.indexOf(type.value) > -1}
                >
                  {t(type.localizationSlug)}
                </Checkbox>
              </li>
            );
          })}
        </ul>
      </Popover>
    );
  }

  renderMarketRegions() {
    const { t } = this.props;
    return (
      <div className="dropdown-filter-wrapper mb-4">
        <label className="form-label block mb-2">{t('FILTER_BY_REGION')}</label>
        <OverlayTrigger
          className="dropdown-filter-wrapper"
          rootClose
          trigger="click"
          placement="bottom"
          overlay={this.renderMarketRegionsPopup()}
        >
          <div>
            <Button
              bsStyle={
                this.state.market_regions.length > 0 ? 'danger' : 'default'
              }
              style={{ outline: 'none' }}
              bsSize="small"
            >
              <strong>{`${t('REGIONS')}: `} </strong>
              <Glyphicon glyph="chevron-down" className="button-down-glyph" />
            </Button>
          </div>
        </OverlayTrigger>
      </div>
    );
  }

  toggleQuickpayCarriers = (value) => {
    this.setState(
      (prev) => {
        return {
          quickpay_carrier: value,
        };
      },
      () => this.updateAccessorialsView(),
    );
  };

  renderToggleQuickpayCarriers() {
    const { t } = this.props;
    return (
      <CargomaticInput
        id="toggle-quickpay-carriers"
        type="checkbox"
        label={t('TOGGLE_QUICKPAY_CARRIERS')}
        value={this.state.quickpay_carrier}
        onChange={this.toggleQuickpayCarriers}
      />
    );
  }

  handleNeedsReviewFilterChange = (checked, value, localizedLabel) => {
    const needs_review = checked ? value === 'enabled' : null;
    const selectedNeedsReviewOption = checked ? localizedLabel : null;
    this.setState({needs_review, selectedNeedsReviewOption}, () => this.onUpdate());
  }


  renderNeedsReviewFilter() {
    const { t } = this.props;
    const options = [{ label: 'Needs Review: True', value: 'enabled', localizationSlug: 'NEEDS_REVIEW_TRUE', localizedLabel: t('NEEDS_REVIEW_TRUE') }, { label: 'Needs Review: False', value: 'disabled', localizationSlug: 'NEEDS_REVIEW_FALSE', localizedLabel: t('NEEDS_REVIEW_FALSE') }];
    return (
      <div className="mt-2">
        <label className="form-label mb-2 block">
          {t('FILTER_BY_AUTO_APPLY_STATUS')}
        </label>  
        <DropdownMenu className="mb-4">
          <DropdownMenuTrigger asChild>
            <UIButton variant="outline" size="sm" className="h-10 gap-1">
              <span className="sr-only sm:not-sr-only sm:whitespace-nowrap">
                {this.state.selectedNeedsReviewOption ?? t('NEEDS_REVIEW')}
              </span>
              <ChevronDownIcon className='ml-2 w-4 h-5' />
            </UIButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            {options.map(({ value, localizationSlug, localizedLabel }) => (
              <DropdownMenuCheckboxItem
                onCheckedChange={(checked) => this.handleNeedsReviewFilterChange(checked, value, localizedLabel)}
                checked={this.state.selectedNeedsReviewOption === localizedLabel}
              >
                {t(localizationSlug)}
              </DropdownMenuCheckboxItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    )
  }

  render() {
    const {
      loading,
      user,
      exceptions,
      openBulkAssignModal,
      selectedIds,
      action,
      showShipmentDetailsModal,
      showShipmentDetailsShipment,
      selected,
    } = this.state;

    const { t } = this.props;

    if (!user) return <div>{t('LOADING')}</div>;

    const selectedAccessorials = exceptions.filter((s) =>
      selectedIds.includes(s._id),
    );

    const autoAppliedNeedsReviewAccessorialPresent = 
      checkIfAccessorialsNeedsReview(selectedAccessorials);
    const missingEquipment = 
      checkIfEquipmentIsMissing(selectedAccessorials);

    return (
      <Container className="py-8">
        <h3 className="my-0 mb-4">{t('ACCESSORIAL_REQUESTS')}</h3>
        <div className="">
          {action === 'edit' && (
            <BulkAddAccessorialsModal
              show
              shipmentIds={selectedAccessorials.map((acc) => acc.shipment._id)}
              onHide={() =>
                this.setState({
                  action: '',
                })
              }
              edit
              selectedAccessorials={selectedIds}
            />
          )}
          {openBulkAssignModal && selectedIds && selectedIds.length && (
            <AccessorialsConfirmationModal
              show
              action={action}
              onHide={() =>
                this.setState({ action: '', openBulkAssignModal: false })
              }
              selectedAccessorials={selectedIds}
              onAccessorialSubmit={this.handleAccessorialOnSubmit}
              handleAccessorialRemove={this.handleAccessorialRemove}
            />
          )}
          {showShipmentDetailsModal && (
            <CargomaticModal
              show
              onHide={this.hideShipmentModal}
              title={titleize(t('DETAIL', { count: 2 }))}
              enforceFocus={false}
              body={
                <ShipmentModule
                  modalID={showShipmentDetailsShipment}
                  dontRefresh
                />
              }
              footer={null}
              location="top"
              dialogClassName="modal-override"
            />
          )}
          {this.renderPane()}
          <div className="filters-wrapper">
            <div className="flex flex-wrap">
              <div className="md:w-1/4 w-full px-4">
                {this.renderShipmentFilter()}
              </div>
              <div className="md:w-1/4 w-full px-4">
                {this.renderMasterAccountFilter()}
              </div>
              <div className="md:w-1/4 w-full px-4">
                {this.renderShipperFilter()}
              </div>
              <div className="md:w-1/4 w-full px-4">
                {this.renderCarrierFilter()}
              </div>
              <div className="md:w-1/4 w-full px-4">
                {this.renderAccesorialTypes()}
              </div>
              <div className="md:w-1/4 w-full px-4">
                {this.renderActionTypes()}
              </div>
              <div className="md:w-1/4 w-full px-4">
                {this.renderFilterbyStatus(true)}
              </div>
              <div className="md:w-1/4 w-full px-4">
                {this.renderFilterbyStatus(false)}
              </div>
              <div className="md:w-1/4 w-full px-4">
                {this.renderPayeeTypeFilter()}
              </div>
              <div className="md:w-1/4 w-full px-4">
                {this.renderOPSGroupFilter()}
              </div>
              <div className="md:w-1/4 w-full px-4">
                {this.renderDateRangeFilter()}
              </div>
              <div className="md:w-1/4 w-full px-4">
                {featureEnabled(CONFIGURED_FEATURES.SSR) &&
                  this.renderMissingDocumentsFilter()}
              </div>
              <div className="md:w-1/2 w-full px-4">
                {this.renderReasonCode()}
              </div>
              <div className="md:w-1/4 w-full px-4">
                {this.renderMarketRegions()}
              </div>
              <div className="md:w-1/4 w-full px-4">
                {this.renderToggleQuickpayCarriers()}
              </div>
              <div className="md:w-1/4 w-full px-4 pb-4">
              {featureEnabled(CONFIGURED_FEATURES?.AUTO_APPLY_ACCESSORIAL) && this.renderNeedsReviewFilter()}
              </div>

            </div>
          </div>
          <div className="flex flex-wrap items-center justify-end mt-6 mb-2">
            <div className="px-2">
              <ExportAccessorialExceptionCSV
                className="dropdown-filter-wrapper"
                exportAccessorialsToCSV={(columns) =>
                  this.exportAccessorialsToCSV(columns)
                }
                exportCSV={this.state.exportCSV}
              />
            </div>
            <div className="px-2">
              <DropdownButton
                id="bulk-actions-dropdown"
                title={t('BULK_ACTIONS')}
                disabled={!selectedIds.length}
                onSelect={this.handleBulkAction}
                bsStyle="success"
                className="button button-green mr-2"
              >
                <MenuItem disabled={!SessionStore.isAdmin()} eventKey="Edit">
                  {titleize(t('EDIT_ACCESSORIAL'))}
                </MenuItem>
                <MenuItem eventKey="Decline">{titleize(t('DECLINE'))}</MenuItem>
                <MenuItem
                  eventKey="Approve"
                  disabled={
                    autoAppliedNeedsReviewAccessorialPresent ||
                    missingEquipment
                  }
                >
                  {titleize(t('APPROVE'))}
                </MenuItem>
                <MenuItem
                  eventKey="Notify Shipper"
                  disabled={
                    autoAppliedNeedsReviewAccessorialPresent ||
                    missingEquipment
                  }
                >
                  {t('NOTIFY_SHIPPER')}
                </MenuItem>
              </DropdownButton>
            </div>
          </div>
          {autoAppliedNeedsReviewAccessorialPresent && (
            <CargomaticAlert
              dataTestId="Alert-Auto-Apply-Bulk-Accessorial-Exception"
              className="my-4"
              type="warning"
            >
              {t('AUTO_APPLY_BULK_ACCESSORIAL_WARNING_MESSAGE')}
            </CargomaticAlert>
          )}
          {missingEquipment && (
            <CargomaticAlert
              dataTestId="Alert-Equipment-Bulk-Accessorial-Exception"
              className="my-4"
              type="error"
            >
              {t("NOT_APPLIED_TO_AN_EQUIPMENT")}
            </CargomaticAlert>
          )}
          <div className="">
            <DataList
              select
              striped
              showHeaders
              remote={{ sort: true }}
              paginate={!loading}
              onTableChange={(type, state) => this.onTableChange(type, state)}
              onClick={(e, row, rowIndex) => this.rowSelected(e, row, rowIndex)}
              data={exceptions}
              columns={AdminAccessorialMapping.columns}
              selected={selectedIds}
              onSelect={(row, selected) => this.handleSelection(row, selected)}
              onSelectAll={(selected) => this.handleSelectAll(selected)}
              noDataIndication={
                loading
                  ? t('LOADING_ACCESSORIALS')
                  : t('ACCESSORIAL_REQUESTS_NOT_FOUND')
              }
              page={this.state.activePage}
              pages={this.state.pages}
              total={this.state.totalCount}
              perPage={this.state.per_page}
              onPaginationSelect={(page) => this.onPaginationSelect(page)}
            />
          </div>
        </div>
      </Container>
    );
  }
}

export default withTranslation()(AccessorialExceptions);
